export default {
  "profileSettings.changePersonalDetails": "Change Personal Details",
  "profileSettings.changePassword": "Change Password",
  "profileSettings.myProfile": "My Profile",
  "profileSettings.profileSettings": "Profile Settings",
};
